import { render } from "./BadgeWithClose.vue?vue&type=template&id=6c409dc6&scoped=true&ts=true"
import script from "./BadgeWithClose.vue?vue&type=script&lang=ts"
export * from "./BadgeWithClose.vue?vue&type=script&lang=ts"

import "./BadgeWithClose.vue?vue&type=style&index=0&id=6c409dc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c409dc6"]])

export default __exports__